import { Alert } from "react-bootstrap";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import { ListarCasoVinculadosAgendamentoController } from "../../../../../Controllers/AssistenciaTecnica/Agendamento/AgendamentoControllers";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import AtendimentoVinculadoDeAgendamento from "./AtendimentoVinculadoDeAgendamento";

interface IAlertaMaisAtendimentoParaProdutoProps {
    ID_COMPROMISSO: number;
}

export default function AlertaMaisAtendimentoParaProduto(
    props: IAlertaMaisAtendimentoParaProdutoProps
) {
    const { loading, value: lstAtendimentosVinculados } = useAsyncEffect(
        () => ListarCasoVinculadosAgendamentoController(props.ID_COMPROMISSO),
        [props.ID_COMPROMISSO]
    );

    const plural =
        lstAtendimentosVinculados && lstAtendimentosVinculados?.length > 1;

    return (
        <div>
            {
                <OrSpinner spinner="capys" loading={loading}>
                    {lstAtendimentosVinculados &&
                        lstAtendimentosVinculados?.length > 0 && (
                            <>
                                <hr />
                                <Alert variant="light">
                                    Existe{plural ? "m" : ""}{" "}
                                    {lstAtendimentosVinculados?.length}{" "}
                                    atendimento{plural ? "s" : ""} de assitência
                                    técnica em aberto para o mesmo local deste
                                    agendamento
                                </Alert>
                                <ul
                                    className="p-0 y-scroll"
                                    style={{
                                        maxHeight: "175px",
                                    }}
                                >
                                    {lstAtendimentosVinculados.map(
                                        (atendimentoVinculado) => (
                                            <AtendimentoVinculadoDeAgendamento
                                                atendimentoVinculado={
                                                    atendimentoVinculado
                                                }
                                                key={
                                                    atendimentoVinculado.ID_CASO
                                                }
                                            />
                                        )
                                    )}
                                </ul>
                            </>
                        )}
                </OrSpinner>
            }
        </div>
    );
}
